import React from 'react';

const DataNotFound = () => {
    return (
        <div>
            <h1 className='text-4xl text-center'>Data not found.</h1>
            <h2 className='text-3xl text-center'>404</h2>
        </div>
    );
};

export default DataNotFound;